module.exports = __webpack_public_path__ + "static/img/img_2.d44541ac.jpg";